import { createAppActorContext } from '@mono-activities/ui'

import { CreateAppStateMachine } from '@/state/AppStateMachine'

const appStateMachine = CreateAppStateMachine()

export const { AppActorContext, AppActorProvider } = createAppActorContext(appStateMachine)
